/* eslint-disable jsx-a11y/alt-text */
import { useMutation } from '@graphcommerce/graphql'
import { Image } from '@graphcommerce/image'
import { i18n } from '@lingui/core'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { GraphQLError } from 'graphql'
import { useState } from 'react'

export type Answers = {
  content: string
}
export type CategoryQuestionAndAnswerItemProps = {
  email: string
  name: string
  short_answer: string
  title: string
  negative_rating: number
  positive_rating: number
  question_id: number
}

export function CategoryQuestionAndAnswerItem(props: CategoryQuestionAndAnswerItemProps) {
  const { email, name, short_answer, title, negative_rating, positive_rating, question_id } = props

  return (
    <div className='flex flex-col items-start justify-start gap-4 md:mb-[20px]'>
      <h3 className='Type-XXL-Medium'>{title}</h3>
      <h3 className='Type-XL-Regular text-[16px] leading-[24px] text-medium-dark-gray'>
        {short_answer}
      </h3>
    </div>
  )
}
